module.exports = __webpack_public_path__ + "static/media/Talon-Redwoods.6a20f5c7.jpeg";